<template>
  <AnalyticsWidget
    title="DIFOT Summary"
    subTitle="Delivered In-Full On-Time summary for orders during the last 30 days"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue title="Operational DIFOT" :helpTip="`Based on ${operationalHitCount} hits and ${operationalMissCount} misses out of ${operationalOrderCount} completed orders (excluding ${operationalExcludeCount} orders flagged as exclude)`">
              {{formatPercent(operationalDIFOT)}}
              <template v-slot:info>Based on {{operationalOrderCount}} completed orders (excluding {{operationalExcludeCount}} orders flagged as exclude)</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue title="Commercial DIFOT" :helpTip="`Based on ${operationalHitCount} hits and ${operationalMissCount} misses out of ${commercialOrderCount} completed orders (includes ${operationalExcludeCount} orders flagged as exclude)`">
              {{formatPercent(commercialDIFOT)}}
              <template v-slot:info>Based on {{commercialOrderCount}} completed orders</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue title="Late Orders">
              {{operationalLateCount}}
              <template v-slot:info>Out of {{operationalOrderCount}} total completed orders</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue title="Customer Caused rate">
              {{formatPercent(totalCustomerCausedRate)}}
              <template v-slot:info>Of all late orders</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>

        <AnalyticsDashboardValueRow>
          <div class="col-3">
            <AnalyticsDashboardValue title="Orders Waiting Outbound">
              {{pendingOutboundCount}}
              <template v-slot:info>Outbound orders currently waiting in despatch</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col-3">
            <AnalyticsDashboardValue title="Orders Waiting Collection">
              {{pendingCollectionCount}}
              <template v-slot:info>Collection orders currently waiting in despatch</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col-3">
            <AnalyticsDashboardValue title="Average Collection Delay">
              {{formatDecimal(averageCollectionDelay, 1)}} Days
              <template v-slot:info>Average time spent waiting collection in {{totalCollectionOrders}} orders collected</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col-3">
            <AnalyticsDashboardValue title="P90 Collection Time">
              {{formatDecimal(p90CollectionTime, 1)}} Days
              <template v-slot:info>90th Percentile in {{totalCollectionOrders}} orders collected</template>
            </AnalyticsDashboardValue>
          </div>

        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

import { TaskTypeCategoryTypes } from '@/store/types'

export default {
  name: 'OrderDIFOTSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    operationalDIFOT() {
      var validOrderCount = this.operationalOrderCount
      if(validOrderCount> 0)
        return (this.operationalHitCount / validOrderCount) * 100
      return 0
    },
    commercialDIFOT() {
      var validOrderCount = this.commercialOrderCount

      if(validOrderCount > 0)
        return (this.operationalHitCount / validOrderCount) * 100
      return 0
    },
    operationalOrderCount() {
      return (this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalOrderCount : 0) - this.operationalNonClassifiedCount - this.operationalExcludeCount
    },
    commercialOrderCount() {
      return (this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalOrderCount : 0) - this.operationalNonClassifiedCount
    },
    operationalHitCount() {
      return this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalHitCount : 0
    },
    operationalMissCount() {
      return this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalMissCount : 0
    },
    operationalExcludeCount() {
      return this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalExcludeCount : 0
    },
    operationalNonClassifiedCount() {
      return this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalNonClassifiedCount : 0
    },
    operationalLateCount() {
      return this.operationalMissCount + this.operationalExcludeCount
    },
    totalCustomerCausedRate() {
      var customerCausedCount = this.summaryData.reportingSummary ? this.summaryData.reportingSummary.totalCustomerCaused : 0
      var totalLate = this.operationalLateCount

      if(totalLate > 0)
        return (customerCausedCount / totalLate) * 100
      return 0
    },
    pendingOutboundCount() {
      return this.pendingDespatchList.filter(order => {
        return order.despatchTaskType && order.despatchTaskType.reportingCategoryType != TaskTypeCategoryTypes.collection
      }).length
    },
    pendingCollectionCount() {
      return this.pendingDespatchList.filter(order => {
        return order.despatchTaskType && order.despatchTaskType.reportingCategoryType == TaskTypeCategoryTypes.collection
      }).length
    },
    averageCollectionDelay() {
      return this.collectionSummary.averageDespatchDurationDays
    },
    totalCollectionOrders() {
      return this.collectionSummary.totalOrderCount
    },
    p90CollectionTime() {
      return this.collectionSummary.p90DespatchDurationDays
    }
  },
  data() {
    return {
      loading: true,
      summaryData: {},
      pendingDespatchList: [],
      collectionSummary: {}
    }
  },
  created() {
  },
  mounted() {
    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      var filter = {
        startDate: moment().subtract(30, 'days').local().startOf('day').toISOString(),
        endDate: moment().local().endOf('day').toISOString()
      }

      Promise.all([
        this.$apiService.analyticsService.getOrderDIFOTSummary(filter),
        this.$apiService.analyticsService.getOrderDIFOTPendingDespatchList(),
        this.$apiService.analyticsService.getDIFOTCollectionSummary(filter)
      ])
      .then(results => {
        this.summaryData = results[0].data
        this.pendingDespatchList = results[1].data
        this.collectionSummary = results[2].data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>